// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3viUz","footer":"ChangeClinic_footer__vAkR0"};